import { normalizeScanStatus } from '../helpers/attachmentScan';
import { isImageAttachment } from '../helpers/supportHelpers';
// ---------------------------------------------------------------------------
// MIME type → Attachment type mapping
// ---------------------------------------------------------------------------
function deriveAttachmentType(mimeType) {
    if (mimeType.startsWith('image/'))
        return 'image';
    if (mimeType.startsWith('audio/'))
        return 'audio';
    return 'document';
}
export function mapUserFileRefToAttachment(ref) {
    return {
        id: ref.file_id,
        name: ref.file_name,
        type: deriveAttachmentType(ref.mime_type),
        status: ref.scan_status,
        errorMessage: ref.error_message
    };
}
export function mapUserFileRefsToAttachments(refs) {
    return refs.map(mapUserFileRefToAttachment);
}
// ---------------------------------------------------------------------------
// UserFileRef → AIHumanSupportAttachment (files an agent sent). No URL: those are short-lived
// and fetched on demand when the customer taps one.
// ---------------------------------------------------------------------------
export function mapSupportAttachments(refs, source = 'support') {
    return refs.map((ref) => ({
        id: ref.file_id,
        name: ref.file_name,
        mimeType: ref.mime_type,
        sizeBytes: ref.file_size_bytes,
        isImage: isImageAttachment(ref),
        // A history row may carry `scan_status: null` (no verdict): that is clean, not "unknown".
        scanStatus: normalizeScanStatus(ref.scan_status),
        source
    }));
}
